import { Link } from 'react-router-dom'

import { Card, EmptyState } from '@/design'

/** The creative report is the next card: until its API lands this says so, and shows no table. */
export function CreativePlaceholderCard() {
  return (
    <Card title="Creative performance">
      <EmptyState
        variant="not-live"
        compact
        title="Coming next"
        description="Spend, results and thumbnails per Meta creative arrive with the creative report."
        action={
          <Link className="ci-button" to="/marketing/creatives">
            Go to Creatives
          </Link>
        }
      />
    </Card>
  )
}
